import Vue from "vue";
import VueRouter from "vue-router";
import routes from "@/routes";
import { accesDecisionService } from "@/services";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
});

router.beforeEach(accesDecisionService.beforeRouterEnter());

export default router;
